export const IconName = {
  bell: "bell",
  bellRing: "bellRing",
  bellSlash: "bellSlash",
  bookmark: "bookmark",
  bricks: "bricks",
  calendar: "calendar",
  calendarX: "calendarX",
  chatAlert: "chatAlert",
  chatBubble: "chatBubble",
  check: "check",
  chevronLeft: "chevronLeft",
  chevronRight: "chevronRight",
  circleHalf: "circleHalf",
  circleEmpty: "circleEmpty",
  circleClock: "circleClock",
  circlePerson: "circlePerson",
  circlePlus: "circlePlus",
  circleX: "circleX",
  clock: "clock",
  envelope: "envelope",
  heart: "heart",
  hearts: "hearts",
  infinity: "infinity",
  link: "link",
  location: "location",
  locationMap: "locationMap",
  locationPlus: "locationPlus",
  locationX: "locationX",
  lock: "lock",
  minus: "minus",
  pencil: "pencil",
  people: "people",
  peoplePlus: "peoplePlus",
  personRunning: "personRunning",
  personWithArmsRaised: "personWithArmsRaised",
  person: "person",
  plus: "plus",
  qrCode: "qrCode",
  star: "star",
  trash: "trash",
  triangleDown: "triangleDown",
  trophy: "trophy",
  trophyWithStar: "trophyWithStar",
  whistle: "whistle",
  wrench: "wrench",
  x: "x",
} as const;

export type IconSize = "small" | "smedium" | "medium" | "marge" | "large" | "xlarge" | "xxlarge";
